import type { Board } from "../board";
import { getMobGoldValue } from "../economy/mobGoldValues";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import { SolidifiedSquid } from "../things/solidifiedSquid";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { WeakMob } from "../weakMob";
import { BasicAI } from "../ai/basicAI";
import type { XY } from "../xy";
import type { PhysicalThing } from "../physicalThing";
import { SquidCorpse } from "./squidCorpse";

export class Squid extends WeakMob {
	static key = "Squid";
	private ai: BasicAI;

	constructor(xy: XY) {
		super(xy);
		this.ai = new BasicAI(this);
		this.ai.attackSoundSupplier = () => new Sound(SoundId.MOB_PHISICAL_ATTACK, this.xy);
		this.ai.noiseSoundSupplier = () => new Sound(SoundId.SQUID_SOUND, this.xy);
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(Squid.key);
	}

	createSolidifiedVariant(): PhysicalThing | null {
		return new SolidifiedSquid(this.xy);
	}

	generateCorpse(): PhysicalThing | null {
		return new SquidCorpse(this.xy);
	}

	override generateDeathSound(): Sound {
		return new Sound(SoundId.SQUID_DIE);
	}

	processMobAction(_board: Board): void {
		this.ai.processTurn();
	}

	static deserialize(data: any): Squid {
		const s = new Squid(deserializeXY(data.xy));
		s.restoreMobFields(data);
		return s;
	}
}
